import React, {useMemo, useState} from "react";
import {useIntl} from "react-intl";
import {useQuery} from "@tanstack/react-query";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {Table, TableData} from "peggirkit";
import {JobOpeningInOverview} from "@/data/entities/jobOpening";
import {getJobOpeningsTableColumns} from "@widgets/jobOpenings/table/JobOpeningsTableColumns";
import {api} from "@/data/api";


const JobOpeningsTable = () => {
    const intl = useIntl();
    const {dashboardLocation} = useRestaurant();
    const [tableData, setTableData] = useState<TableData<JobOpeningInOverview>[]>([]);
    const {isFetching} = useQuery({
        queryKey: ["delivery-areas", dashboardLocation.id],
        queryFn: async () => {
            const result: JobOpeningInOverview[] = await api.jobOpening.listJobOpenings(dashboardLocation.id);
            setTableData(result);
            return result;
        },
    });
    const columns = useMemo(() => getJobOpeningsTableColumns(intl, setTableData), [intl, setTableData]);

    return (
        <Table<JobOpeningInOverview>
            columns={columns}
            data={tableData}
            setData={setTableData}
            loading={isFetching}
            loadingConfig={{
                skeletonRepeat: 6,
            }}
            rowConfig={{
                hoverEffect: true,
            }}
        />
    );
};

export default JobOpeningsTable;